import React, { useEffect, useRef, useState } from 'react';
import DarkNav from './DarkNav';
import Footer from './Footer';
import "./RocketNew.css";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import Navbar2 from './Navbar2';
import SmoothScroll from "smooth-scroll";
function RocketNew() {

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });


  const { scrollYProgress } = useScroll();
  const { scrollY } = useScroll();
  const x = useTransform(scrollY, [3000,5000], [0, -700])


    const scaleX = useSpring(scrollYProgress, {
      stiffness: 100,
      damping: 30,
      restDelta: 0.001
    });

    const ref = useRef(null);
    const { scrollXProgress } = useScroll({ container: ref });
    const [activeTab, setActiveTab] = useState("Tab1");
    const videoRefs = [useRef(null), useRef(null)]; // Refs for multiple videos
    const [videoStates, setVideoStates] = useState([
        { isPlaying: true, isEnded: false }, // Initial states for each video
        { isPlaying: true, isEnded: false },
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Play/Pause Handler
    const togglePlayPause = (index) => {
        const video = videoRefs[index].current;
        const updatedStates = [...videoStates];

        if (video.paused) {
            video.play();
            updatedStates[index] = { isPlaying: true, isEnded: false };
        } else {
            video.pause();
            updatedStates[index] = { isPlaying: false, isEnded: false };
        }
        setVideoStates(updatedStates);
    };

    // Replay Handler
    const handleReplay = (index) => {
        const video = videoRefs[index].current;
        video.currentTime = 0;
        video.play();

        const updatedStates = [...videoStates];
        updatedStates[index] = { isPlaying: true, isEnded: false };
        setVideoStates(updatedStates);
    };

    // Handle Video End
    const handleVideoEnd = (index) => {
        const updatedStates = [...videoStates];
        updatedStates[index] = { isPlaying: false, isEnded: true };
        setVideoStates(updatedStates);
    };

    const renderContent = () => {
        switch (activeTab) {
            case "Tab1":
                return (
                    <div>
                        <div className='RocketSolOne'>
                            <div className='SolOneLeft'>
                                <img src='/images/Sol1.gif' alt="video" />
                            </div>
                            <div className='SolOneRight'>
                                <h1 className='title1'><span>Pre-load</span> <br /> experience</h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                <img src='/images/Sol1Image.png' alt="image" />
                            </div>
                        </div>


                        <div className='RocketSolTwo'>
                            <div className='SolOneLeft2'>
                                <img src='/images/Sol2.gif' alt="video" />
                            </div>
                            <div className='SolOneRight2'>
                                <h1 className='title2'><span>Visual feedback</span> <br /> and insights for users</h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                <img src='/images/Sol2Image.png' alt="image" />
                            </div>
                        </div>


                        <div className='RocketSolThree'>
                            <div className='SolOneLeft3'>
                                <img src='/images/Sol3.png' alt="video" />
                            </div>
                            <div className='SolOneRight2 sol3Right'>
                            <img src='/images/Sol32.png' alt="image" />
                                <h1 className='title3'><span>Quick</span> connect via Text</h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                            </div>
                        </div>

                        <div className='RocketSolFour'>
                            <div className='SolOneLeft3'>
                                <img src='/images/Sol4.png' alt="video" />
                            </div>
                            <div className='SolOneRight2 sol4Right'>
                                <h1 className='title4'> Encouraging users to <span>provide their phone number</span></h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                <img src='/images/Sol42.png' alt="image" />
                            </div>
                        </div>


                        <div className='RocketSolTwo solFive'>
                            <div className='SolOneLeft2 sol5Left'>
                                <img src='/images/Sol5.gif' alt="video" />
                            </div>
                            <div className='SolOneRight2 sol5'>
                                <h1 className='title5'>Providing<span> assurance </span> <br /> to building sense of <span>excitement</span></h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                <img src='/images/Sol52.png' alt="image" />
                            </div>
                        </div>



                       
                    </div>
                );
            case "Tab2":
                return <div>
                    <div className='RocketSolOne RocketSolOneAnother'>
                            <div className='SolOneLeft SolOneLeftNew'>
                                <img src='/images/Sol11.gif' alt="video" />
                            </div>
                            <div className='SolOneRight'>
                                <h1 className='title1 title11'><span>Pre-filling</span> user’s info <br /> coming from realtor.com</h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                <img src='/images/Photo11.svg' alt="image" />
                            </div>
                        </div>

                        <div className='RocketSolOne RocketSolTwoAnother'>
                            <div className='SolOneLeft SolOnetNew'>
                                <img src='/images/Rates.gif' alt="video" />
                            </div>
                            <div className='SolOneRight SolOneRight2'>
                                <h1 className='title1 title11'> Adding <span>rate animation</span> to rocketmortgage.com</h1>
                                <p>Creating a pre-load interstitial that gives users a brief description about the offers provided</p>
                                {/* <img src='/images/Photo11.svg' alt="image" /> */}
                            </div>
                        </div>
                </div>;
            default:
                return null;
        }
    };





    

  return (
    <div className='rocketNew'>
        <DarkNav />
    <motion.div className="progress-bar2" style={{ scaleX }} />
        <div className='RN'>
            
            <div className='RN_Header'>
                <div className='homeLeft_RN'>
                    <div className='homeLeft_Top_RN'>
                        <p>Optimizing Rocket's</p>
                    </div>
                    <div className='homeLeft_Bottom_RN'>
                        <p>Lead Gen Form</p>
                        <p>With AI & testings</p>
                        <p>To drive conversions</p>
                    </div>
                </div>
                <div className='project_Info'>
                    <div className='project_Info_Timeline'>
                        <h5>TIMELINE</h5>
                        <p>May 2024 - Present</p>
                    </div>
                    <div className='project_Info_Role'>
                        <h5>ROLE</h5>
                        <p>Assoc. Product Designer</p>
                    </div>
                    <div className='project_Info_Tools'>
                        <h5>TOOLS</h5>
                        <p>Figma</p>
                        <p>Photoshop</p>
                        <p>Adobe Creative Suite</p>
                    </div>
                    <div className='project_Info_Teams'>
                        <h5>TEAMS</h5>
                        <p>1 <span className='myspan'>(Design Director) </span>, <br />
1 <span className='myspan'>(Content Designer)</span>, <br /> 2 <span className='myspan'>(Product Designers)</span>, <br />6 <span className='myspan'>(PMs)</span>, <br />
8 <span className='myspan'>(Engineers)</span>, <br />
other stakeholder 
and I</p>
                    </div>
                    <div className='project_Info_ProjectType'>
                        <h5>PROJECT TYPE</h5>
                        <p>Industry</p>
                    </div>
                    <div className='project_Info_ProjectFocus'>
                        <h5>PROJECT FOCUS</h5>
                        <p>Research</p>
                        <p>Experience Design</p>
                        <p>Visual Design</p>
                        <p>AI</p>
                    </div>
                </div>
            </div>

            {/* <div style={{margin:"25px 0px"}}>
                <p>PROJECT SHOWREEL</p>
            </div> */}

            <div className='project_Overview'>
                <div className='project_Overview_Left' id='overview'>
                    <p>OVERVIEW</p>
                    <div className='project_Overview_Left_Link'>
                        <p><a data-scroll style={{textDecoration:"none", color:"#000000"}} href='#solution'>SKIP TO THE JUICY PART</a></p>
                        <img src='/images/RocketLinkArrow.svg' alt="link arrow" />
                    </div>
                </div>
                <div className='project_Overview_Right'>
                  <h2>ABOUT ROCKET MORTGAGE</h2>
                    <p>Rocket Mortgage is America’s largest mortgage lender, helping millions achieve the dream of home ownership. Their mission is to  make the complicated home financing process simpler</p>
                    <br />
                    <h2>WHAT DOES THE LEAD GENERATION TEAM DO?</h2>
                    <p>The lead generation team operates at the top of the mortgage platform funnel. We provide users with a form to fill out, and then we connect them with a banker, aiming to successfully convert them into customers.</p>
                </div>
            </div>

            <div className='border2 border3'></div>


            {/* <div className='project_Overview'>
                <div className='project_Overview_Left' id='overview'>
                    <p>RECAP <br /><span style={{fontFamily: "Fragment", fontStyle:"italic", fontSize: "16px", color: "#5D5D5D", letterSpacing: "0px"}}>Of my 2023 internship</span></p>
                    <div className='project_Overview_Left_Link'>
                        <p><a data-scroll style={{textDecoration:"none", color:"#000000"}} href='#solution'>GO TO PREVIOUS LAUNCHPAD CASE</a></p>
                        <img src='/images/RocketLinkArrow.svg' alt="link arrow" />
                    </div>
                </div>
                <div className='project_Overview_Right'>
                  <h2>PROBLEMS THEN</h2>
                  <p>

                    <ol>
                        <li className='newlist'>Bankers don’t get all the information.</li>
                        <li className='newlist'>Users have to fill out the same form irrespective of their need. </li>
                        <li className='newlist'>Form was not informative about the choices and options.</li>
                    </ol>
                    </p>

                    <br />
                    <h2>SOLUTIONS THEN</h2>
                    <p> <ol>
                        <li className='newlist'>Showing Users Rates who are looking for mortgage rates </li>
                        <li className='newlist'>Guiding Users with insights</li>
                        <li className='newlist'>Providing visual feedback</li>
                        <li className='newlist'>Assisting Users with Unfamiliar Questions</li>
                        <li className='newlist'>Personalized Thank You Pages</li>
                        </ol>
                        </p>
                </div>
            </div> */}

            <div className='border2 border3'></div>

            <div className='project_Vague_ProblemStatement project_Vague_ProblemStatement_Rocket2'>
                <h2>THE <span style={{fontFamily:"Fragment"}}>'</span> <span style={{fontWeight:"200"}}>LATEST</span> <span style={{fontFamily:"Fragment"}}>'</span> PROBLEM STATEMENT</h2>
                <p>How might we improve the lead gen conversions with user intuitive experiences and AI to help them achieve their goal faster.</p>
            </div>

            <div className='project_Vague_WhyRedesign project_Vague_WhyRedesignRocket'>
                <p>But what’s different and new in this case study?</p>
                <p style={{fontFamily:"Inter", fontSize: "24px", fontWeight: "500", fontStyle:"normal", width: "80%", margin:"auto", lineHeight:"130%", letterSpacing:"-3%", marginTop:"-150px", color:"#000000"}}>This case study won’t show you the end to end design process.
                    <br />
                    <br/>

<span style={{color:"#575757"}}>This case study highlights my work at Rocket, showcasing concepts & it’s designs, smooth animations, amazing prototypes, and creative assets aimed at improving conversion rates. </span></p>
            </div>



            <div className='project_Research_Header old_version RDS' id='solution'>
                <div className='project_Research_Header_Left old_version_left project_Research_Header_Left_Rocket'>
                <div className='project_Research_Header_Left_Top'>

                </div>
                <div className='project_Research_Header_Left_Bottom'>
                    <p></p>
                </div>

                </div>
                <div className='project_Research_Header_Right old_version_right project_Research_Header_Left_Rocket'>
                    <div className='project_Research_Header_Right_Top'>
                        <h1>Design & </h1>
                        <h1>Concepts</h1>
                    </div>
                    <div className='project_Research_Header_Right_Bottom project_Research_Header_Right_Bottom_Rocket'>
                        <p> &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp;                     The Designs and concepts are divided into 2 sections. One where I try to create designs within launchpad to improve conversions and other is where the design aim to direct more traffic to launchpad.</p>
                    </div>
                </div>
            </div>


            <div className="tabs">
        <button
          className={`tab ${activeTab === "Tab1" ? "active" : ""}`}
          onClick={() => setActiveTab("Tab1")}
        >

       <p  className='boldp'> <span className='newspan'>Boosting conversions</span> within <span className='newspan'>launchpad </span></p>

        </button>

        <button
          className={`tab ${activeTab === "Tab2" ? "active" : ""}`}
          onClick={() => setActiveTab("Tab2")}
        >
       <p className='boldp'>  <span className='newspan'>Bringing more traffic</span> to <span className='newspan'>launchpad</span></p>
        </button>
      </div>
      <div className="content">{renderContent()}</div>

      <div className='project_Reflection'>
                <h2>REFLECTION</h2>
                <div className='project_Reflection_Text'>
                    <div className='project_Reflection_Text_Left'>
                        <img src="/images/Key.svg" alt="reflection image" />
                        <h2>Collaboration is the key</h2>
                        <p>Projects will be successful only if there is constant collaboration  between the PMs, designers, dev and the marketing team.</p>
                    </div>
                    <div className='project_Reflection_Text_Middle'>
                        <img src="/images/Bulb.svg" alt="reflection image" />
                        <h2>Communicate complex/unique ideas</h2>
                        <p>Never be afraid to communicate complex/unique ideas, you might never know if the thing will work or not unless you build and test it.</p>
                    </div>
                    <div className='project_Reflection_Text_Right'>
                        <img src="/images/Empathy.svg" alt="reflection image" />
                        <h2>Empathize with everyone and embrace feedback</h2>
                        <p>Show compassion and understanding towards all individuals, fostering a culture of inclusivity. Welcome feedback as a valuable tool for personal growth and continuous improvement.</p>
                    </div>
                </div>
                {/* <ScrollToTop 
                color='#FB8842'
                top={500} smooth /> */}

            </div>
            <Footer />
            


    </div>
    </div>

  )
}

export default RocketNew;